import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { TableData } from "@/App/Roles/Table";
import { getRolesData, searchRoleData } from "@/Api/roles";
import { Button } from "@/components/ui/button";
import { CirclePlus, Briefcase } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { PageHeader } from "@/components/PageHeader";

export type TableDataProps = {
  id: number;
  uuid: string;
  name: string;
  is_active: boolean;
  tenant_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  tenant: {
    id: number;
    name: string;
  };
};

export const PageList = () => {
  const [listData, setListData] = useState<TableDataProps[]>([]);
  const [state, setState] = useState("loading");
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  useEffect(() => {
    (async () => {
      const { data } = await getRolesData();
      setListData(data?.response);
      setState("production");
    })();
  }, []);

  return (
    <Main>
      <If condition={hasPermission("view-positions-list")}>
        <PageHeader
          icon={Briefcase}
          title="Cargos"
          description="Gerencie os cargos e permissoes"
        >
          <If condition={hasPermission("create-position")}>
            <Button
              variant="outline"
              className={cn("py-3 flex gap-1", `bg-primary`)}
              onClick={() => navigate("/cargos/adicionar")}
            >
              <CirclePlus className="size-5" strokeWidth={1.75} />
              Adicionar Cargo
            </Button>
          </If>
        </PageHeader>
        <div className="flex flex-col gap-3">
          <SearchComponent
            updateFront={setListData}
            setState={setState}
            funcSearch={searchRoleData}
            placeholder="Pesquisar"
          />
          {state === "loading" ? (
            <CreateLoaderTable cols={4} lines={6} />
          ) : (
            <TableData dataApi={listData} updateFront={setListData} />
          )}
        </div>
      </If>
    </Main>
  );
};
